import { get, getToken } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LSNG_ADMIN_API_URL;

const loadApplicationTheme = () => get(`${url}/branding/theme?access_token=${getToken()}`);

const exp = { loadApplicationTheme };

export default exp;
